/**
 * API base URL para el proxy de imágenes.
 * Usa Vercel CDN cache (s-maxage) para evitar re-ejecutar la función en cada request.
 * Cuando Wasabi habilite acceso público, cambiar a URL directa de Wasabi.
 */
const API_BASE = process.env.REACT_APP_API_URL || '';

/**
 * Verifica si una URL es de Wasabi
 * @param {string} url - URL a verificar
 * @returns {boolean}
 */
export const isWasabiUrl = (url) => {
  return url && url.includes('wasabisys.com');
};

/**
 * Obtiene la URL correcta para mostrar una imagen.
 * Usa el proxy con cache agresivo en Vercel CDN.
 * @param {string} imageUrl - URL original de la imagen
 * @returns {string} - URL procesada para mostrar
 */
export const getDisplayImageUrl = (imageUrl) => {
  if (!imageUrl) return '/placeholder-image.svg';
  
  // Si es URL de Wasabi, extraer el path y usar el proxy cacheado
  if (isWasabiUrl(imageUrl)) {
    const match = imageUrl.match(/rementerprisesecommerce\/(.+)$/);
    if (match) {
      return `${API_BASE}/media/view/${match[1]}`;
    }
  }
  
  // Si es otra URL externa válida, usarla directamente
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // Si ya es una ruta del proxy, usarla directamente
  if (imageUrl.startsWith('/api/media/view/')) {
    return imageUrl;
  }

  // Si es una ruta local absoluta (ej: /images/slider/..., /placeholder-image.svg), usarla directo
  if (imageUrl.startsWith('/')) {
    return imageUrl;
  }
  
  // Si es una ruta relativa (ej: productos/2025/06/prod_xxx.jpg), usar proxy
  return `${API_BASE}/media/view/${imageUrl}`;
};

/**
 * @deprecated Usar getDisplayImageUrl en su lugar. Mantenido por compatibilidad.
 */
export const getProxyImageUrl = (wasabiUrl) => {
  return getDisplayImageUrl(wasabiUrl);
};
